import { render, staticRenderFns } from "./PaymentModalTopMessage.vue?vue&type=template&id=ebb208fe&scoped=true&"
import script from "./PaymentModalTopMessage.vue?vue&type=script&lang=ts&"
export * from "./PaymentModalTopMessage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentModalTopMessage.vue?vue&type=style&index=0&id=ebb208fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb208fe",
  null
  
)

export default component.exports